export default __webpack_public_path__ + "static/media/page1.0ce9025d.png";